export default __webpack_public_path__ + "static/6662-fac74efa80e43e3de4dd72ab220ef596.jpg";